<template>
	<div class="map-root">
		<!-- ========== 2D/3D 切换按钮 ========== -->
		<!-- <button @click="toggle3D"
			style="position:absolute; top:10px; left:10px; z-index:100; padding:8px 16px; background:#1890ff; color:#fff; border:none; border-radius:4px; cursor:pointer;">
			{{ is3D ? '切换到2D' : '切换到3D' }}
		</button> -->
		<!-- ========== 地图容器 ========== -->
		<div id="map-container" style="width:100%; height:100vh;"></div>

		<div class="dialog-mask" v-if="dialogQxVisible" @click="dialogQxVisible = false">
			<div class="dialog-card" @click.stop>
				<div class="dialog-title">气象站</div>
				<div class="dialog-close" @click="dialogQxVisible = false">×</div>
				<div class="dialog-content text-grid">
					<div>温度: 22℃</div>
					<div>湿度: 70.7%</div>
					<div>空气质量: 44ug</div>
					<div>等级: 2级</div>
					<div>描述: 优良</div>
					<div>风力: 东南风 2级 6km/h</div>
				</div>
			</div>
		</div>

		<div class="dialog-mask" v-if="dialogSqVisible" @click="dialogSqVisible = false">
			<div class="dialog-card" @click.stop>
				<div class="dialog-title">土壤墒情</div>
				<div class="dialog-close" @click="dialogSqVisible = false">×</div>
				<div class="dialog-content text-grid" v-if="sqData">
					<div>土壤上层温度: {{ sqData.wd1 }}℃</div>
					<div>土壤上层水分: {{ sqData.sf1 }}%</div>
					<div>土壤中层温度: {{ sqData.wd2 }}℃</div>
					<div>土壤中层水分: {{ sqData.sf2 }}%</div>
					<div>土壤下层温度: {{ sqData.wd3 }}℃</div>
					<div>土壤下层水分: {{ sqData.sf3 }}%</div>
					<div>土壤电导率: {{ sqData.ddl }}</div>
					<div>土壤PH值: {{ sqData.ph }}</div>
				</div>
			</div>
		</div>

		<div class="dialog-mask" v-if="dialogMqVisible" @click="closeMonitorDialog">
			<div class="dialog-card video-card" @click.stop>
				<div class="dialog-title">苗情影像</div>
				<div class="dialog-close" @click="closeMonitorDialog">×</div>
				<div id="mse" class="video-box"></div>
			</div>
		</div>

		<div class="dialog-mask" v-if="dialogCqVisible" @click="dialogCqVisible = false">
			<div class="dialog-card" @click.stop>
				<div class="dialog-title">虫情</div>
				<div class="dialog-close" @click="dialogCqVisible = false">×</div>
				<div class="cont" style="background-color: #071f39; width: 800px; height: 480px">
					<div class="cq" style="margin-top: 5px">
						<!-- <div class="fout-emotions-title">虫情</div> -->
						<div class="content flex alit">
							<img src="https://ica.obs.cn-south-1.myhuaweicloud.com/screen/fourEmotions/%E8%99%AB%E6%83%85%E6%B5%8B%E6%8A%A5%E4%BB%AA.png"
								style="width: 270px; height: 440px; margin: 0 10px" alt="" />
				
							<div class="" style="flex: 1; margin-right: 20px; margin-left: 40px">
								<div class="flex justb" style="margin-right: 10px; width: 300px">
									<div class="flex alit cq-right-top-title">运行模式</div>
									<div class="flex justb" style="flex: 1">
										<div class="sd" v-if="operatingMode" @click="operatingMode = false">
											手动
										</div>
										<div class="zd" v-else @click="operatingMode = true">
											自动
										</div>
										<div class="paizhao flex alit justc">
											<img style="width: 21px; height: 17px; margin-right: 10px"
												src="https://ica.obs.cn-south-1.myhuaweicloud.com/screen/fourEmotions/%E6%8B%8D%E7%85%A7%E7%9B%B8%E6%9C%BA%402x.png"
												alt="" />
											拍照
										</div>
									</div>
								</div>
								<div class="flex justb" style="flex: 1; margin: 70px 10px 18px 0">
									<div class="flex alit">
										<div class="cq-right-top-title">诱虫灯</div>
										<div class="switch-group">
											<div class="cq-right-top-status">
												{{ value1 ? "开" : "关" }}
											</div>
											<el-switch v-model="value1" :width="47" active-color="#53c556"
												inactive-color="#b2b2b2" />
										</div>
									</div>
									<div class="flex alit" style="margin-right: 70px">
										<div class="cq-right-top-title2">虫雨挡板</div>
										<div class="switch-group">
											<div class="cq-right-top-status">
												{{ value2 ? "开" : "关" }}
											</div>
											<el-switch v-model="value2" :width="47" active-color="#53c556"
												inactive-color="#b2b2b2">
											</el-switch>
										</div>
									</div>
								</div>
								<div class="flex justb" style="flex: 1; margin: 70px 10px 18px 0">
									<div class="flex alit">
										<div class="cq-right-top-title">杀虫挡板</div>
										<div class="switch-group">
											<div class="cq-right-top-status">
												{{ value3 ? "开" : "关" }}
											</div>
											<el-switch v-model="value3" :width="47" active-color="#53c556"
												inactive-color="#b2b2b2">
											</el-switch>
										</div>
									</div>
									<div class="flex alit" style="margin-right: 70px">
										<div class="cq-right-top-title2">烘干挡板</div>
										<div class="switch-group">
											<div class="cq-right-top-status">
												{{ value4 ? "开" : "关" }}
											</div>
											<el-switch v-model="value4" :width="47" active-color="#53c556"
												inactive-color="#b2b2b2">
											</el-switch>
										</div>
									</div>
								</div>
								<div class="flex justb" style="flex: 1; margin: 70px 10px 18px 0">
									<div class="flex alit">
										<div class="cq-right-top-title">移虫装置</div>
										<div class="switch-group">
											<div class="cq-right-top-status">
												{{ value5 ? "开" : "关" }}
											</div>
											<el-switch v-model="value5" :width="47" active-color="#53c556"
												inactive-color="#b2b2b2">
											</el-switch>
										</div>
									</div>
									<div class="flex alit" style="margin-right: 70px">
										<div class="cq-right-top-title2">杀虫控制</div>
										<div class="switch-group">
											<div class="cq-right-top-status">
												{{ value6 ? "开" : "关" }}
											</div>
											<el-switch v-model="value6" :width="47" active-color="#53c556"
												inactive-color="#b2b2b2">
											</el-switch>
										</div>
									</div>
								</div>
							</div>
						</div>
				
					</div>
				</div>
			</div>
		</div>

		<div class="dialog-mask" v-if="dialogBzVisible" @click="dialogBzVisible = false">
			<div class="dialog-card"  @click.stop>
				<div class="dialog-title">孢子检测仪</div>
				<div class="dialog-close" @click="dialogBzVisible = false">×</div>
				<div class="cont" style="background-color: #071f39; width: 800px; height: 480px">
					<div class="cq" style="margin-top: 5px">
						<div class="fout-emotions-title">孢子</div>
						<div class="content flex alit">
							<img src="https://ica.obs.cn-south-1.myhuaweicloud.com/screen/fourEmotions/a645441470ef28a9f892f3713c55f4b7.png"
								style="width: 230px; height: 400px; margin: 20px" alt="" />
				
							<div class="" style="flex: 1; margin-right: 20px; margin-left: 40px">
								<div class="flex justb" style="margin-right: 10px; width: 300px">
									<div class="flex alit cq-right-top-title">运行模式</div>
									<div class="flex justb" style="flex: 1">
										<div class="sd" v-if="operatingMode" @click="operatingMode = false">
											手动
										</div>
										<div class="zd" v-else @click="operatingMode = true">
											自动
										</div>
										<div class="paizhao flex alit justc">
											<img style="width: 21px; height: 17px; margin-right: 10px"
												src="https://ica.obs.cn-south-1.myhuaweicloud.com/screen/fourEmotions/%E6%8B%8D%E7%85%A7%E7%9B%B8%E6%9C%BA%402x.png"
												alt="" />
											拍照
										</div>
									</div>
								</div>
				
								<div class="flex justb" style="flex: 1; margin: 70px 10px 18px 0">
									<div class="flex alit">
										<div class="cq-right-top-title">光源</div>
										<div class="switch-group">
											<div class="cq-right-top-status">
												{{ value1 ? "开" : "关" }}
											</div>
											<el-switch v-model="value1" :width="47" active-color="#53c556"
												inactive-color="#b2b2b2" />
										</div>
									</div>
									<div class="flex alit" style="margin-right: 70px">
										<div class="cq-right-top-title2">吸风风扇</div>
										<div class="switch-group">
											<div class="cq-right-top-status">
												{{ value2 ? "开" : "关" }}
											</div>
											<el-switch v-model="value2" :width="47" active-color="#53c556"
												inactive-color="#b2b2b2">
											</el-switch>
										</div>
									</div>
								</div>
								<div class="flex justb" style="flex: 1; margin: 70px 10px 18px 0">
									<div class="flex alit">
										<div class="cq-right-top-title">排风风扇</div>
										<div class="switch-group">
											<div class="cq-right-top-status">
												{{ value3 ? "开" : "关" }}
											</div>
											<el-switch v-model="value3" :width="47" active-color="#53c556"
												inactive-color="#b2b2b2">
											</el-switch>
										</div>
									</div>
									<div class="flex alit" style="margin-right: 70px">
										<div class="cq-right-top-title2">载波带电机运行</div>
										<div class="switch-group">
											<div class="cq-right-top-status">
												{{ value4 ? "开" : "关" }}
											</div>
											<el-switch v-model="value4" :width="47" active-color="#53c556"
												inactive-color="#b2b2b2">
											</el-switch>
										</div>
									</div>
								</div>
								<div class="flex justb" style="flex: 1; margin: 70px 10px 18px 0">
									<div class="flex alit">
										<div class="cq-right-top-title">采样电机运行</div>
										<div class="switch-group">
											<div class="cq-right-top-status">
												{{ value5 ? "开" : "关" }}
											</div>
											<el-switch v-model="value5" :width="47" active-color="#53c556"
												inactive-color="#b2b2b2">
											</el-switch>
										</div>
									</div>
								</div>
							</div>
						</div>
					</div>
				</div>
			</div>
		</div>

		<div class="dialog-mask"  v-if="irrigation" @click="irrigation = false">
			<div class=" irrigation-card" style="position: relative;" @click.stop>
				<div class="dialog-close" style="top: 50px;z-index: 99999;color: #fff;" @click="irrigation = false">×</div>
				<irrigation-vue></irrigation-vue>
			</div>
		</div>

	</div>
</template>

<script>
	// ============================================================================
	// 1. 导入 OpenLayers 核心库
	// ============================================================================
	import 'ol/ol.css';
	import {
		Map,
		View
	} from 'ol';
	import TileLayer from 'ol/layer/Tile';
	import XYZ from 'ol/source/XYZ';
	import {
		fromLonLat
	} from 'ol/proj';
	import VectorLayer from 'ol/layer/Vector';
	import VectorSource from 'ol/source/Vector';
	import Feature from 'ol/Feature';
	import Point from 'ol/geom/Point';
	import Polygon from 'ol/geom/Polygon';
	import LineString from 'ol/geom/LineString';
	import {
		Style,
		Fill,
		Stroke,
		Icon
	} from 'ol/style';

	// ============================================================================
	// 2. 导入 Cesium 3D 相关
	// ============================================================================
	import OLCesium from 'olcs/OLCesium.js';
	import irrigationVue from './irrigation.vue';
	import Player from 'xgplayer';
	import FlvPlugin from 'xgplayer-flv';
	import 'xgplayer/dist/index.min.css';

		export default {
			name: 'MapComponent',
			components: {
				irrigationVue,
			},
		props: {
			zoom: {
				type: Number,
				default: 15,
			},
			initial3D: {
				type: Boolean,
				default: false,
			},
		},

		data() {
			return {
				value1: false,
				value2: false,
				value3: false,
				value4: false,
				value5: false,
				value6: false,
				operatingMode: true, //运行模式 true 手动 false 自动
				// OpenLayers 地图实例
				map: null,
				// ol-cesium 实例
				ol3d: null,
				// 当前是否为 3D 模式
				is3D: false,
				// 是否默认进入 3D，由父组件按场景控制
				defaultTo3D: this.initial3D,
				// 2D / 3D 视角参数分开维护，避免中心点和姿态互相影响
				viewConfig2D: {
					center: [100.362315, 38.904672],
					zoom: 15.1,
				},
				viewConfig3D: {
					center: [100.362315, 36.404672],
					height: 900000,
					heading: 0,
					pitch: 70,
					roll: 0,
				},

				// 甘肃 GeoJSON 数据地址
				gansuGeoJSONUrl: 'https://qgst.obs.cn-southwest-2.myhuaweicloud.com/rabbit/pc/geoJson/%E7%94%98%E8%82%83%E7%9C%813.geoJson',

				// 存储甘肃边界的坐标
				gansuBorderCoords: [],

				// Cesium 围栏/标记实体名称列表（用于清理）
				cesiumFenceNames: ['3D区域遮罩', '3D区域顶面', '3D主围栏', '3D顶部流动线', '3D光晕墙体', '3D发光线条', '3D自定义标记点'],
				// 3D 初始化重试定时器
				cesiumInitTimer: null,
				// Cesium 点击事件处理器
				cesiumClickHandler: null,
				// 2D 图标图层与数据源
				markerLayer2D: null,
				markerSource2D: null,
				// 2D 地块面图层与数据源
				devicePolygonLayer2D: null,
				devicePolygonSource2D: null,
				// 地块原始数据，供 2D / 3D 复用
				devicePolygonList: [],
				// 2D 管线图层与数据源
				waterPipeLayer2D: null,
				waterPipeSource2D: null,
				// 2D 设备 marker 图层与数据源
				deviceMarkerLayer2D: null,
				deviceMarkerSource2D: null,
				player: null,
				irrigation: false,
				dialogMqVisible: false,
				dialogCqVisible: false,
				dialogSqVisible: false,
				dialogQxVisible: false,
				dialogBzVisible: false,
				sqData: null,
			};
		},

		mounted() {
			this.initMap();
			this.$nextTick(() => {
				this.loadGansuGeoJSON();
			});
		},

		beforeDestroy() {
			if (this.cesiumInitTimer) {
				clearTimeout(this.cesiumInitTimer);
				this.cesiumInitTimer = null;
			}
			if (this.ol3d) {
				this.ol3d.setEnabled(false);
			}
			if (this.cesiumClickHandler) {
				this.cesiumClickHandler.destroy();
				this.cesiumClickHandler = null;
			}
			if (this.map) {
				this.map.setTarget(null);
				this.map.dispose();
			}
			if (this.player) {
				this.player.destroy();
				this.player = null;
			}
		},

		methods: {
			/**
			 * ================================================================
			 * 5.1 初始化地图
			 * ================================================================
			 */
			initMap() {
				if (typeof window.Cesium === 'undefined') {
					console.error('❌ Cesium 未正确加载');
					return;
				}

				// ---------- 创建底图 ----------
				const tileLayer = new TileLayer({
					source: new XYZ({
						url: 'https://map.snkoudai.com/maps/vt/lyrs=s&hl=zh-CN&gl=cn&scale=1&x={x}&y={y}&z={z}',
						maxZoom: 18,
					}),
				});

			// ---------- 创建地图 ----------
			this.map = new Map({
				target: 'map-container',
				layers: [tileLayer],
				view: new View({
					center: fromLonLat(this.viewConfig2D.center),
					zoom: this.viewConfig2D.zoom,
				}),
			});

				this.init2DMarkerLayer();
				this.init2DDevicePolygonLayer();
				this.init2DWaterPipeLayer();
				this.init2DDeviceMarkerLayer();

				// ---------- 创建 ol-cesium 3D 实例 ----------
				this.ol3d = new OLCesium({
					map: this.map,
					viewerOptions: {
						baseLayerPicker: false,
						geocoder: false,
						timeline: false,
						animation: false,
						sceneModePicker: false,
						requestRenderMode: true,
						terrainProvider: new window.Cesium.EllipsoidTerrainProvider(),
					},
				});

			console.log('✅ 地图初始化完成');
		},

		apply2DView() {
			if (!this.map) return;

			const view = this.map.getView();
			view.setCenter(fromLonLat(this.viewConfig2D.center));
			view.setZoom(this.viewConfig2D.zoom);
		},

		apply3DView() {
			if (!this.ol3d || typeof window.Cesium === 'undefined') return;

			const scene = this.ol3d.getCesiumScene();
			if (!scene || !scene.camera) return;

			const Cesium = window.Cesium;
			const camera = scene.camera;
			const {
				center,
				height,
				heading,
				pitch,
				roll,
			} = this.viewConfig3D;

			camera.setView({
				destination: Cesium.Cartesian3.fromDegrees(center[0], center[1], height),
				orientation: {
					heading: Cesium.Math.toRadians(heading),
					pitch: Cesium.Math.toRadians(-pitch),
					roll: Cesium.Math.toRadians(roll),
				},
			});

			if (scene.requestRender) {
				scene.requestRender();
			}
		},

		/**
		 * ================================================================
		 * 5.1.1 初始化 2D 图标图层
		 * ================================================================
		 * 2D 模式下的图片点位用 OpenLayers Feature + Icon 实现
			 * 这样不会影响现有 3D 实体逻辑，也方便后续继续往图层里追加设备点位
			 */
			init2DMarkerLayer() {
				if (!this.map || this.markerLayer2D) return;

				this.markerSource2D = new VectorSource();
				this.markerLayer2D = new VectorLayer({
					source: this.markerSource2D,
					zIndex: 40,
					name: '2D图标层',
				});

				this.map.addLayer(this.markerLayer2D);

				// 2D 模式下添加可点击图标
				this.add2DClickableMarker({
					position: [100.362315, 38.905872],
					icon: '/xin-dun-shuangbao.png',
					width: 134,
					height: 137,
					offset: [0, -38],
					id: 'water-valve-device',
				});

				this.map.on('singleclick', (event) => {
					const feature = this.map.forEachFeatureAtPixel(event.pixel, (currentFeature, layer) => {
						if (layer && layer.get('name') === '2D图标层') {
							return currentFeature;
						}
						return null;
					});

					if (feature) {
						this.handle2DMarkerClick(feature);
					}
				});

				this.map.on('pointermove', (event) => {
					const hit = this.map.hasFeatureAtPixel(event.pixel, {
						layerFilter: (layer) => layer.get('name') === '2D图标层',
					});
					this.map.getTargetElement().style.cursor = hit ? 'pointer' : '';
				});
			},

			/**
			 * 在 2D 地图上添加一个可点击的图片图标
			 */
			add2DClickableMarker({
				position,
				icon,
				id,
				width = 30,
				height = 30,
				offset = [0, 0],
			}) {
				if (!this.markerSource2D) return;

				const markerFeature = new Feature({
					geometry: new Point(fromLonLat(position)),
					markerId: id,
					markerPosition: position,
				});

				// OpenLayers 里 imgSize 不是显示尺寸，这里按图片真实宽高换算 scale，稳定控制到指定宽高
				const markerImage = new Image();
				markerImage.onload = () => {
					const scaleX = width / markerImage.width;
					const scaleY = height / markerImage.height;

					markerFeature.setStyle(
						new Style({
							image: new Icon({
								src: icon,
								scale: [scaleX, scaleY],
								anchor: [0.5, 1],
								displacement: offset,
							}),
						})
					);
				};

				markerImage.src = icon;

				this.markerSource2D.addFeature(markerFeature);
			},

			/**
			 * 2D 图标点击回调
			 * 先保留一个清晰入口，后续你接弹窗、详情或设备跳转时直接在这里接业务即可
			 */
			handle2DMarkerClick(feature) {
				console.log('✅ 点击了 2D 图标', {
					id: feature.get('markerId'),
					position: feature.get('markerPosition'),
				});
			},

			/**
			 * 控制 2D 图标层显隐，避免切到 3D 时干扰当前场景
			 */
			set2DMarkerVisibility(visible) {
				if (this.markerLayer2D) {
					this.markerLayer2D.setVisible(visible);
				}
				if (this.deviceMarkerLayer2D) {
					this.deviceMarkerLayer2D.setVisible(visible);
				}
				if (this.devicePolygonLayer2D) {
					this.devicePolygonLayer2D.setVisible(visible);
				}
				if (this.waterPipeLayer2D) {
					this.waterPipeLayer2D.setVisible(visible);
				}
			},

			/**
			 * 控制 2D 遮罩与围栏图层显隐。
			 * 首页默认直接进入 3D 时，如果这几层仍然可见，会被同步到 Cesium 场景里，视觉上容易出现整屏发黑。
			 */
			set2DOverlayVisibility(visible) {
				if (!this.map) return;

				this.map.getLayers().getArray().forEach((layer) => {
					const name = layer.get('name');
					if (name === '遮罩层' || name === '围栏层' || name === '发光围栏') {
						layer.setVisible(visible);
					}
				});
			},

			/**
			 * ================================================================
			 * 5.2 加载甘肃 GeoJSON
			 * ================================================================
			 */
			async loadGansuGeoJSON() {
				try {
					console.log('🔄 开始加载甘肃 GeoJSON...');
					const response = await fetch(this.gansuGeoJSONUrl);
					if (!response.ok) {
						throw new Error(`HTTP error! status: ${response.status}`);
					}
					const geojsonData = await response.json();
					console.log('✅ GeoJSON 加载成功');

					this.gansuBorderCoords = this.extractCoordinatesFromGeoJSON(geojsonData);

					if (!this.gansuBorderCoords || this.gansuBorderCoords.length === 0) {
						console.error('❌ 未能从 GeoJSON 提取有效坐标');
						return;
					}

					console.log(`✅ 提取到 ${this.gansuBorderCoords.length} 个坐标环`);

					// 创建 2D 遮罩层
					this.createMaskLayer();
					// 创建 2D 围栏
					this.createFenceEffect();

					// 加载接口返回的地块 Polygon，并转换成当前 OpenLayers 地图方案
					this.loadDevicePolygons();

					// 适配地图视野
					this.fitToGansu();

					if (this.defaultTo3D && !this.is3D) {
						this.$nextTick(() => {
							this.toggle3D();
						});
					}

					console.log('✅ 遮罩 + 围栏创建完成');
				} catch (error) {
					console.error('❌ 加载 GeoJSON 失败:', error);
					this.createFallbackMask();
				}
			},

			/**
			 * ================================================================
			 * 5.3 从 GeoJSON 提取坐标
			 * ================================================================
			 */
			extractCoordinatesFromGeoJSON(geojson) {
				const coordinates = [];

				const extractFromGeometry = (geometry) => {
					if (!geometry) return;

					if (geometry.type === 'Polygon') {
						const exteriorRing = geometry.coordinates[0];
						if (exteriorRing && exteriorRing.length > 0) {
							const ring = exteriorRing.slice(0, -1);
							coordinates.push(ring);
						}
					} else if (geometry.type === 'MultiPolygon') {
						geometry.coordinates.forEach((polygonCoords) => {
							const exteriorRing = polygonCoords[0];
							if (exteriorRing && exteriorRing.length > 0) {
								const ring = exteriorRing.slice(0, -1);
								coordinates.push(ring);
							}
						});
					} else if (geometry.type === 'GeometryCollection') {
						geometry.geometries.forEach((geom) => {
							extractFromGeometry(geom);
						});
					}
				};

				if (geojson.type === 'FeatureCollection') {
					geojson.features.forEach((feature) => {
						extractFromGeometry(feature.geometry);
					});
				} else if (geojson.type === 'Feature') {
					extractFromGeometry(geojson.geometry);
				} else {
					extractFromGeometry(geojson);
				}

				return coordinates;
			},

			/**
			 * ================================================================
			 * 5.4 创建遮罩层（2D）
			 * ================================================================
			 */
			createMaskLayer() {
				const worldBounds = [
					[-180, -90],
					[180, -90],
					[180, 90],
					[-180, 90],
					[-180, -90],
				];

				const worldBoundsProjected = worldBounds.map((coord) => fromLonLat(coord));

				const gansuCoordsProjected = this.gansuBorderCoords.map((ring) =>
					ring.map((coord) => fromLonLat(coord))
				);

				const maskPolygonCoords = [
					worldBoundsProjected,
					...gansuCoordsProjected,
				];

				const maskPolygon = new Polygon(maskPolygonCoords);
				const maskFeature = new Feature({
					geometry: maskPolygon,
					name: '遮罩层',
				});

				maskFeature.setStyle(
					new Style({
						fill: new Fill({
							color: 'rgba(35, 54, 34, 0.78)',
						}),
						stroke: new Stroke({
							color: 'rgba(35, 54, 34, 0.18)',
							width: 1,
						}),
					})
				);

				const maskSource = new VectorSource({
					features: [maskFeature],
				});

				const maskLayer = new VectorLayer({
					source: maskSource,
					zIndex: 20,
					name: '遮罩层',
				});

				this.map.addLayer(maskLayer);
				console.log('✅ 遮罩层添加成功');
			},

			/**
			 * ================================================================
			 * 5.5 创建围栏效果（2D 模式）
			 * ================================================================
			 */
			createFenceEffect() {
				// 移除旧的围栏图层
				this.removeFenceLayers();

				this.gansuBorderCoords.forEach((ring, index) => {
					const closedRing = [...ring, ring[0]];
					const borderCoords = closedRing.map((coord) => fromLonLat(coord));

					// ---------- 主围栏（虚线 + 发光） ----------
					const line = new LineString(borderCoords);
					const feature = new Feature({
						geometry: line,
						name: `围栏-${index}`,
					});

					feature.setStyle(
						new Style({
							stroke: new Stroke({
								color: '#00ff88',
								width: 4,
								lineDash: [12, 8],
							}),
						})
					);

					const borderSource = new VectorSource({
						features: [feature],
					});

					const borderLayer = new VectorLayer({
						source: borderSource,
						zIndex: 25,
						name: '围栏层',
					});

					this.map.addLayer(borderLayer);
				});

				// ---------- 发光围栏（外发光效果） ----------
				this.createGlowFence();

				console.log('✅ 2D 围栏效果添加成功');
			},

			/**
			 * 2D 发光围栏（底层粗线条模拟光晕）
			 */
			createGlowFence() {
				this.gansuBorderCoords.forEach((ring) => {
					const closedRing = [...ring, ring[0]];
					const borderCoords = closedRing.map((coord) => fromLonLat(coord));

					const line = new LineString(borderCoords);
					const feature = new Feature({
						geometry: line,
						name: '发光围栏',
					});

					feature.setStyle(
						new Style({
							stroke: new Stroke({
								color: 'rgba(0, 255, 136, 0.3)',
								width: 12,
								lineDash: [12, 8],
							}),
						})
					);

					const glowSource = new VectorSource({
						features: [feature],
					});

					const glowLayer = new VectorLayer({
						source: glowSource,
						zIndex: 24,
						name: '发光围栏',
					});

					this.map.addLayer(glowLayer);
				});
			},

			/**
			 * ================================================================
			 * 5.6 移除 2D 围栏图层
			 * ================================================================
			 */
			removeFenceLayers() {
				const layers = this.map.getLayers().getArray();
				const toRemove = [];
				layers.forEach((layer) => {
					const name = layer.get('name');
					if (name === '围栏层' || name === '发光围栏') {
						toRemove.push(layer);
					}
				});
				toRemove.forEach((layer) => {
					this.map.removeLayer(layer);
				});
			},

			/**
			 * ================================================================
			 * 5.1.2 初始化 2D 地块面图层
			 * ================================================================
			 * 对应 map.vue 中 for 循环创建 AMap.Polygon 的那套逻辑
			 * 当前页改成 OpenLayers 的 Feature + Polygon + VectorLayer
			 */
			init2DDevicePolygonLayer() {
				if (!this.map || this.devicePolygonLayer2D) return;

				this.devicePolygonSource2D = new VectorSource();
				this.devicePolygonLayer2D = new VectorLayer({
					source: this.devicePolygonSource2D,
					zIndex: 26,
					name: '2D地块面图层',
				});

				this.map.addLayer(this.devicePolygonLayer2D);

				this.map.on('singleclick', (event) => {
					const feature = this.map.forEachFeatureAtPixel(event.pixel, (currentFeature, layer) => {
						if (layer && layer.get('name') === '2D地块面图层') {
							return currentFeature;
						}
						return null;
					});

					if (feature) {
						this.handle2DPolygonClick(feature);
					}
				});
			},

			/**
			 * 初始化 2D 管线图层
			 * 对应 map.vue 中 waterPipe -> AMap.Polyline / Polyline2 的逻辑
			 */
			init2DWaterPipeLayer() {
				if (!this.map || this.waterPipeLayer2D) return;

				this.waterPipeSource2D = new VectorSource();
				this.waterPipeLayer2D = new VectorLayer({
					source: this.waterPipeSource2D,
					zIndex: 27,
					name: '2D管线图层',
					style: (feature) => {
						const pipeType = feature.get('pipeType');
						if (pipeType === 'inner') {
							return new Style({
								stroke: new Stroke({
									color: '#005ACF',
									width: 3,
									lineCap: 'round',
									lineJoin: 'round',
								}),
							});
						}

						return new Style({
							stroke: new Stroke({
								color: '#97EDFF',
								width: 5,
								lineCap: 'round',
								lineJoin: 'round',
							}),
						});
					},
				});

				this.map.addLayer(this.waterPipeLayer2D);
			},

			/**
			 * 初始化 2D 设备 marker 图层
			 */
			init2DDeviceMarkerLayer() {
				if (!this.map || this.deviceMarkerLayer2D) return;

				this.deviceMarkerSource2D = new VectorSource();
				this.deviceMarkerLayer2D = new VectorLayer({
					source: this.deviceMarkerSource2D,
					zIndex: 41,
					name: '2D设备标记层',
				});

				this.map.addLayer(this.deviceMarkerLayer2D);

				this.map.on('singleclick', (event) => {
					const feature = this.map.forEachFeatureAtPixel(event.pixel, (currentFeature, layer) => {
						if (layer && layer.get('name') === '2D设备标记层') {
							return currentFeature;
						}
						return null;
					});

					if (feature) {
						this.handle2DDeviceMarkerClick(feature);
					}
				});
			},

			/**
			 * intelligentControl.vue 会调用 this.$refs.maps.setMarkers(res)
			 * 这里保持同名接口，test.vue 只负责把设备数据渲染到地图上，不再重复维护 deviceCount 业务
			 */
			setMarkers(response) {
				this.setDeviceMarkers(response);
			},

			/**
			 * 兼容 intelligentControl.vue 现有调用
			 * 目前 test.vue 暂不实现水阀分组绘制，先保留空方法避免页面报错
			 */
			openGroupMarkers() {},
			closeGroupMarkers() {},

			setDeviceMarkers(response) {
				if (!this.deviceMarkerSource2D) return;
				this.deviceMarkerSource2D.clear();

				const list = Array.isArray(response?.data) ? response.data : [];
				for (let i = 0; i < list.length; i++) {
					const item = list[i];
					const config = this.getDeviceMarkerConfig(item.type);

					this.add2DDeviceMarker({
						position: [item.lon, item.lat],
						icon: config.image,
						width: config.width,
						height: config.height,
						markerData: item,
					});
				}
			},

			getDeviceMarkerConfig(type) {
				switch (type) {
					case 1:
						return {
							image: 'https://ica.obs.cn-south-1.myhuaweicloud.com/screen/intelligentControl/%E6%B0%B4%E8%82%A5%E6%9C%BA%E8%AE%BE%E5%A4%87%402x.png',
							width: 47,
							height: 92,
						};
					case 2:
						return {
							image: '/water-valve-device.png',
							width: 30,
							height: 40,
						};
					case 3:
						return {
							image: 'https://ica.obs.cn-south-1.myhuaweicloud.com/screen/intelligentControl/%E8%8B%97%E6%83%85%E8%AE%BE%E5%A4%87%402x.png',
							width: 47,
							height: 92,
						};
					case 4:
						return {
							image: 'https://ica.obs.cn-south-1.myhuaweicloud.com/screen/intelligentControl/%E6%B0%94%E8%B1%A1%E8%AE%BE%E5%A4%87%402x.png',
							width: 47,
							height: 92,
						};
					case 5:
						return {
							image: 'https://ica.obs.cn-south-1.myhuaweicloud.com/screen/intelligentControl/%E5%A2%92%E6%83%85%E8%AE%BE%E5%A4%87%402x.png',
							width: 47,
							height: 92,
						};
					case 6:
						return {
							image: 'https://ica.obs.cn-south-1.myhuaweicloud.com/screen/intelligentControl/%E5%AD%A2%E5%AD%90%E8%AE%BE%E5%A4%87%402x.png',
							width: 47,
							height: 92,
						};
					case 7:
						return {
							image: 'https://ica.obs.cn-south-1.myhuaweicloud.com/screen/intelligentControl/%E8%99%AB%E6%83%85%E8%AE%BE%E5%A4%87%402x.png',
							width: 47,
							height: 92,
						};
					case 8:
						return {
							image: 'https://ica.obs.cn-south-1.myhuaweicloud.com/screen/intelligentControl/%E6%9D%80%E8%99%AB%E7%81%AF%E8%AE%BE%E5%A4%87%402x.png',
							width: 47,
							height: 92,
						};
					default:
						return {
							image: '/water-valve-device.png',
							width: 30,
							height: 40,
						};
				}
			},

			add2DDeviceMarker({
				position,
				icon,
				width,
				height,
				markerData,
			}) {
				if (!this.deviceMarkerSource2D) return;

				const markerFeature = new Feature({
					geometry: new Point(fromLonLat(position)),
					markerData,
				});

				const markerImage = new Image();
				markerImage.onload = () => {
					const scaleX = width / markerImage.width;
					const scaleY = height / markerImage.height;
					markerFeature.setStyle(new Style({
						image: new Icon({
							src: icon,
							scale: [scaleX, scaleY],
							anchor: [0.5, 1],
						}),
					}));
				};
				markerImage.src = icon;
				this.deviceMarkerSource2D.addFeature(markerFeature);
			},

			handle2DDeviceMarkerClick(feature) {
				const data = feature.get('markerData');
				if (!data) return;

				if (data.type === 1) {
					this.irrigation = true;
				}

				if (data.type === 3) {
					const videoUrl = JSON.parse(data.config || '{}').live_flv_hd;
					this.dialogMqVisible = true;
					this.$nextTick(() => {
						if (this.player) {
							this.player.destroy();
							this.player = null;
						}

						this.player = new Player({
							id: 'mse',
							url: videoUrl,
							playsinline: true,
							width: 800,
							height: 450,
							videoInit: true,
							cssFullscreen: true,
							ignores: ['fullscreen'],
							plugins: [FlvPlugin],
							autoplayMuted: true,
							autoplay: true,
						});
					});
				}

				if (data.type === 7) {
					this.dialogCqVisible = true;
				}

				if (data.type === 5) {
					this.sqData = this.getSoilDataById(data.id);
					this.dialogSqVisible = true;
				}

				if (data.type === 4) {
					this.dialogQxVisible = true;
				}

				if (data.type === 6) {
					this.dialogBzVisible = true;
				}
			},

			closeMonitorDialog() {
				this.dialogMqVisible = false;
				if (this.player) {
					this.player.destroy();
					this.player = null;
				}
			},

			getSoilDataById(id) {
				const soilDataMap = {
					1073: { wd1: 0.9, sf1: 8.9, wd2: 2.1, sf2: 17.6, wd3: 2.9, sf3: 19.0, ddl: 0.0, ph: 3.0 },
					1074: { wd1: -0.8, sf1: 9.2, wd2: 1.2, sf2: 12.9, wd3: 1.2, sf3: 12.8, ddl: 0.0, ph: 6.7 },
					1075: { wd1: 0.1, sf1: 3.9, wd2: 0.0, sf2: 8.0, wd3: 0.2, sf3: 5.9, ddl: 0.0, ph: 6.4 },
					1076: { wd1: 3.7, sf1: 13.6, wd2: 4.9, sf2: 46.5, wd3: 5.6, sf3: 18.1, ddl: 0.0, ph: 5.7 },
					1077: { wd1: 0.6, sf1: 13.9, wd2: 1.6, sf2: 17.7, wd3: 1.6, sf3: 20.1, ddl: 0.0, ph: 9.0 },
					1078: { wd1: 0.6, sf1: 9.3, wd2: 1.7, sf2: 17.3, wd3: 2.5, sf3: 18.2, ddl: 0.0, ph: 4.5 },
					1079: { wd1: 2.0, sf1: 9.1, wd2: 3.7, sf2: 18.1, wd3: 4.2, sf3: 18.9, ddl: 0.0, ph: 6.6 },
					1080: { wd1: 0.0, sf1: 0.0, wd2: 0.0, sf2: 0.0, wd3: 0.0, sf3: 0.0, ddl: 0.0, ph: 0.0 },
					1081: { wd1: 0.0, sf1: 0.0, wd2: 0.0, sf2: 0.0, wd3: 0.0, sf3: 0.0, ddl: 0.0, ph: 0.0 },
					1082: { wd1: 0.0, sf1: 0.0, wd2: 0.0, sf2: 0.0, wd3: 0.0, sf3: 0.0, ddl: 0.0, ph: 0.0 },
				};

				return soilDataMap[id] || { wd1: 0.0, sf1: 0.0, wd2: 0.0, sf2: 0.0, wd3: 0.0, sf3: 0.0, ddl: 0.0, ph: 0.0 };
			},

			/**
			 * ================================================================
			 * 5.2.1 请求设备列表并转换地块 Polygon
			 * ================================================================
			 * 参考 map.vue 中：
			 * for (let i = 0; i < mapData.length; i++) {
			 *   let data = JSON.parse(mapData[i].latLonPath)
			 * }
			 */
			async loadDevicePolygons(type = '') {
				if (!this.devicePolygonSource2D || !this.waterPipeSource2D || !this.$request) return;

				try {
					const response = await this.$request(`iot/device/list?type=${type}`);
					const mapData = Array.isArray(response?.data) ? response.data : [];
					this.devicePolygonList = mapData;

					this.devicePolygonSource2D.clear();
					this.waterPipeSource2D.clear();
					this.addDevicePolygonsTo2DMap(mapData);
					if (this.is3D) {
						this.addDevicePolygonsTo3DMap(mapData);
					}
				} catch (error) {
					console.error('❌ 加载设备 Polygon 失败:', error);
				}
			},

			/**
			 * 把接口返回的数组批量转换成 OpenLayers Polygon
			 */
			addDevicePolygonsTo2DMap(mapData) {
				if (!this.devicePolygonSource2D || !Array.isArray(mapData)) return;

				const dkColor = [
					'rgb(37, 170, 128)',
					'#7ebe7a',
					'#6c924f',
					'#3f8a3b',
				];

				for (let i = 0; i < mapData.length; i++) {
					const currentItem = mapData[i];
					if (!currentItem?.latLonPath) continue;

					try {
						const data = JSON.parse(currentItem.latLonPath);
						if (!Array.isArray(data) || !data.length) continue;

						const polygonPath = data.map((item) => fromLonLat([item.longitude, item.latitude]));
						const firstPoint = polygonPath[0];
						const lastPoint = polygonPath[polygonPath.length - 1];
						const isClosed = firstPoint && lastPoint && firstPoint[0] === lastPoint[0] && firstPoint[1] === lastPoint[1];
						const ring = isClosed ? polygonPath : [...polygonPath, firstPoint];

						const polygonFeature = new Feature({
							geometry: new Polygon([ring]),
							polygonIndex: i,
							polygonData: currentItem,
						});

						polygonFeature.setStyle(
							new Style({
								stroke: new Stroke({
									color: '#ffffff',
									width: 2,
								}),
								fill: new Fill({
									color: this.hexToRgba(dkColor[i % dkColor.length], 0.5),
								}),
							})
						);

						this.devicePolygonSource2D.addFeature(polygonFeature);
						this.addWaterPipesTo2DMap(currentItem);
					} catch (error) {
						console.warn('⚠️ 单个设备 Polygon 解析失败:', currentItem, error);
					}
				}
			},

			/**
			 * 把单条设备数据里的 waterPipe 转成当前地图里的 2D 管线
			 * 对应 map.vue 里：
			 * let poliList = mapData[i].waterPipe.split('#')
			 */
			addWaterPipesTo2DMap(deviceItem) {
				if (!this.waterPipeSource2D || !deviceItem?.waterPipe) return;

				const poliList = deviceItem.waterPipe.split('#').filter(Boolean);

				for (let j = 0; j < poliList.length; j++) {
					try {
						const data = JSON.parse(poliList[j]);
						if (!Array.isArray(data) || !data.length) continue;

						const path = data.map((item) => fromLonLat([item.longitude, item.latitude]));

						const outerPipeFeature = new Feature({
							geometry: new LineString(path),
							pipeType: 'outer',
							pipeData: deviceItem,
						});

						const innerPipeFeature = new Feature({
							geometry: new LineString(path),
							pipeType: 'inner',
							pipeData: deviceItem,
						});

						this.waterPipeSource2D.addFeature(outerPipeFeature);
						this.waterPipeSource2D.addFeature(innerPipeFeature);
					} catch (error) {
						console.warn('⚠️ 单条 waterPipe 解析失败:', deviceItem, error);
					}
				}
			},

			/**
			 * 3D 模式下补充地块面，不渲染 waterPipe
			 */
			addDevicePolygonsTo3DMap(mapData) {
				const entities = this.getCesiumEntities();
				const Cesium = window.Cesium;
				if (!entities || !Cesium || !Array.isArray(mapData)) return;

				this.removeDevicePolygons3D();

				const dkColor = [
					'rgb(37, 170, 128)',
					'#7ebe7a',
					'#6c924f',
					'#3f8a3b',
				];

				for (let i = 0; i < mapData.length; i++) {
					const currentItem = mapData[i];
					if (!currentItem?.latLonPath) continue;

					try {
						const data = JSON.parse(currentItem.latLonPath);
						if (!Array.isArray(data) || !data.length) continue;

						const degreesArray = data.flatMap((item) => [item.longitude, item.latitude]);
						const fillColor = Cesium.Color.fromCssColorString(dkColor[i % dkColor.length]).withAlpha(0.5);

						entities.add({
							name: '3D地块面',
							entityType: '3D地块面',
							polygon: {
								hierarchy: Cesium.Cartesian3.fromDegreesArray(degreesArray),
								material: fillColor,
								outline: true,
								outlineColor: Cesium.Color.WHITE,
								height: 50,
							},
						});
					} catch (error) {
						console.warn('⚠️ 3D 地块 Polygon 解析失败:', currentItem, error);
					}
				}
			},

			removeDevicePolygons3D() {
				const entities = this.getCesiumEntities();
				if (!entities) return;

				const toRemove = [];
				entities.values.forEach((entity) => {
					if (entity.entityType === '3D地块面') {
						toRemove.push(entity);
					}
				});

				toRemove.forEach((entity) => {
					entities.remove(entity);
				});
			},

			/**
			 * 2D 地块点击回调
			 */
			handle2DPolygonClick(feature) {
				const polygonData = feature.get('polygonData');
				console.log('✅ 点击了 2D Polygon', polygonData);

				if (polygonData?.id && this.$router) {
					// this.$router.push({
					// 	path: '/farming',
					// 	query: {
					// 		id: polygonData.id,
					// 		type: 2,
					// 	},
					// });
				}
			},

			/**
			 * 把 rgb/hex 颜色统一转成带透明度的 rgba
			 */
			hexToRgba(color, alpha) {
				if (color.startsWith('rgb')) {
					return color.replace('rgb(', 'rgba(').replace(')', `, ${alpha})`);
				}

				let hex = color.replace('#', '');
				if (hex.length === 3) {
					hex = hex.split('').map((char) => char + char).join('');
				}

				const r = parseInt(hex.slice(0, 2), 16);
				const g = parseInt(hex.slice(2, 4), 16);
				const b = parseInt(hex.slice(4, 6), 16);
				return `rgba(${r}, ${g}, ${b}, ${alpha})`;
			},

			/**
			 * ================================================================
			 * 5.1.1 添加 3D 自定义标记点
			 * ================================================================
			 * 高德原写法是：Marker + setContent(markerContent)
			 * 这里改成 Cesium 实体：point 负责底部锚点，label 负责文字标牌
			 */
			addCesiumCustomMarker({
				name,
				position,
				height = 0,
				image = '/xin-dun-shuangbao.png',
				width = 134,
				heightPx = 137,
				offset = [0, 8],
			}) {
				const entities = this.getCesiumEntities();
				const Cesium = window.Cesium;
				const scene = this.ol3d?.getCesiumScene?.();

				if (!entities || !Cesium) return;

				const markerPosition = Cesium.Cartesian3.fromDegrees(position[0], position[1], height);
				const markerImageUrl = image;

				const addMarkerEntity = (imageSource) => {
					if (!imageSource) return;

					entities.add({
						name,
						entityType: '3D自定义标记点',
						position: markerPosition,
						billboard: {
							image: imageSource,
							width,
							height: heightPx,
							scale: 1,
							sizeInMeters: false,
							horizontalOrigin: Cesium.HorizontalOrigin.CENTER,
							verticalOrigin: Cesium.VerticalOrigin.BOTTOM,
							heightReference: Cesium.HeightReference.NONE,
							// 用屏幕像素偏移微调图标锚点，等价于高德 Marker 的 offset
							pixelOffset: new Cesium.Cartesian2(offset[0], offset[1]),
							scaleByDistance: undefined,
							pixelOffsetScaleByDistance: undefined,
							disableDepthTestDistance: Number.POSITIVE_INFINITY,
						},
					});

					if (scene?.requestRender) {
						scene.requestRender();
					}
				};

				const markerImage = new Image();
				markerImage.onload = () => {
					console.log('✅ 3D 标记点图片加载成功');
					addMarkerEntity(markerImage);
				};
				markerImage.onerror = () => {
					console.warn('⚠️ 3D 标记点图片预加载失败，改由 Cesium 直接加载 URL');
					addMarkerEntity(markerImageUrl);
				};
				markerImage.src = markerImageUrl;
			},

			initCesiumClickHandler() {
				if (!this.ol3d || typeof window.Cesium === 'undefined') return;

				const scene = this.ol3d.getCesiumScene();
				const Cesium = window.Cesium;
				if (!scene || !scene.canvas) return;

				if (this.cesiumClickHandler) {
					this.cesiumClickHandler.destroy();
				}

				this.cesiumClickHandler = new Cesium.ScreenSpaceEventHandler(scene.canvas);
				this.cesiumClickHandler.setInputAction((movement) => {
					if (!this.is3D) return;

					const pickedObject = scene.pick(movement.position);
					const entity = pickedObject?.id;
					if (!entity) return;

					if (entity.name === '新敦镇双堡村') {
						this.flyTo3DMarker([100.362315, 38.878672], 4500);
					}

					if (entity.name === '张掖市') {
						this.$emit('open-zzym');
					}
				}, Cesium.ScreenSpaceEventType.LEFT_CLICK);
			},

			flyTo3DMarker(position, height = 2500) {
				if (!this.ol3d || typeof window.Cesium === 'undefined') return;

				const scene = this.ol3d.getCesiumScene();
				const Cesium = window.Cesium;
				if (!scene || !scene.camera) return;

				scene.camera.flyTo({
					destination: Cesium.Cartesian3.fromDegrees(position[0], position[1], height),
					orientation: {
						heading: Cesium.Math.toRadians(0),
						pitch: Cesium.Math.toRadians(-55),
						roll: 0,
					},
					duration: 1.2,
				});
			},

			/**
			 * 获取 ol-cesium 默认数据源中的实体集合
			 */
			getCesiumEntities() {
				if (!this.ol3d || !this.ol3d.getDataSourceDisplay) return null;

				const dataSourceDisplay = this.ol3d.getDataSourceDisplay();
				return dataSourceDisplay?.defaultDataSource?.entities || null;
			},

			/**
			 * 生成白色立体区域材质
			 */
			createFenceGradientMaterial(Cesium) {
				const canvas = document.createElement('canvas');
				canvas.width = 96;
				canvas.height = 256;

				const ctx = canvas.getContext('2d');
				if (!ctx) {
					return Cesium.Color.fromCssColorString('rgba(255, 255, 255, 0.6)');
				}

				ctx.fillStyle = 'rgba(255, 255, 255, 0.6)';
				ctx.fillRect(0, 0, canvas.width, canvas.height);

				const gradient = ctx.createLinearGradient(0, canvas.height, 0, 0);
				gradient.addColorStop(0, 'rgba(255, 255, 255, 0.08)');
				gradient.addColorStop(0.55, 'rgba(255, 255, 255, 0.02)');
				gradient.addColorStop(1, 'rgba(255, 255, 255, 0.18)');
				ctx.fillStyle = gradient;
				ctx.fillRect(0, 0, canvas.width, canvas.height);

				const gradientImage = canvas.toDataURL('image/png');

				return new Cesium.ImageMaterialProperty({
					image: gradientImage,
					transparent: true,
				});
			},

			/**
			 * 生成几乎透明、仅边缘略有存在感的顶面材质
			 */
			createTopSurfaceMaterial(Cesium) {
				const canvas = document.createElement('canvas');
				canvas.width = 256;
				canvas.height = 256;

				const ctx = canvas.getContext('2d');
				if (!ctx) {
					return Cesium.Color.fromCssColorString('#233622').withAlpha(0.04);
				}

				ctx.clearRect(0, 0, canvas.width, canvas.height);

				// 外圈轻阴影，中间基本透明，保留一点顶部边缘存在感
				const edgeFade = ctx.createRadialGradient(
					canvas.width / 2,
					canvas.height / 2,
					canvas.width * 0.28,
					canvas.width / 2,
					canvas.height / 2,
					canvas.width * 0.52
				);
				edgeFade.addColorStop(0, 'rgba(35, 54, 34, 0)');
				edgeFade.addColorStop(0.72, 'rgba(35, 54, 34, 0.01)');
				edgeFade.addColorStop(0.9, 'rgba(35, 54, 34, 0.04)');
				edgeFade.addColorStop(1, 'rgba(35, 54, 34, 0.09)');
				ctx.fillStyle = edgeFade;
				ctx.fillRect(0, 0, canvas.width, canvas.height);

				// 很淡的边框光，避免顶面完全消失
				ctx.strokeStyle = 'rgba(255,255,255,0.08)';
				ctx.lineWidth = 2;
				ctx.strokeRect(3, 3, canvas.width - 6, canvas.height - 6);

				const topImage = canvas.toDataURL('image/png');

				return new Cesium.ImageMaterialProperty({
					image: topImage,
					transparent: true,
				});
			},

			/**
			 * 注册并创建顶部流动线材质
			 */
			createFlowLineMaterial(Cesium, options = {}) {
				if (!Cesium.Material.PolylineFlowLineType) {
					const flowCanvas = document.createElement('canvas');
					flowCanvas.width = 256;
					flowCanvas.height = 32;
					const flowCtx = flowCanvas.getContext('2d');

					if (flowCtx) {
						const flowGradient = flowCtx.createLinearGradient(0, 0, flowCanvas.width, 0);
						flowGradient.addColorStop(0, 'rgba(255,255,255,0)');
						flowGradient.addColorStop(0.2, 'rgba(120,255,214,0.15)');
						flowGradient.addColorStop(0.45, 'rgba(180,255,235,0.95)');
						flowGradient.addColorStop(0.55, 'rgba(255,255,255,1)');
						flowGradient.addColorStop(0.8, 'rgba(120,255,214,0.2)');
						flowGradient.addColorStop(1, 'rgba(255,255,255,0)');
						flowCtx.fillStyle = flowGradient;
						flowCtx.fillRect(0, 0, flowCanvas.width, flowCanvas.height);
					}

					const flowImage = flowCanvas.toDataURL('image/png');

					Cesium.Material.PolylineFlowLineType = 'PolylineFlowLine';
					Cesium.Material.PolylineFlowLineImage = flowImage;
					Cesium.Material._materialCache.addMaterial(Cesium.Material.PolylineFlowLineType, {
						fabric: {
							type: Cesium.Material.PolylineFlowLineType,
							uniforms: {
								color: Cesium.Color.WHITE,
								image: Cesium.Material.PolylineFlowLineImage,
								time: 0,
								repeat: new Cesium.Cartesian2(6, 1),
							},
							source: `
							czm_material czm_getMaterial(czm_materialInput materialInput)
							{
								czm_material material = czm_getDefaultMaterial(materialInput);
								vec2 st = materialInput.st;
								vec4 colorImage = texture(image, vec2(fract(st.s * repeat.x - time), st.t * repeat.y));
								material.alpha = colorImage.a * color.a;
								material.diffuse = mix(color.rgb, colorImage.rgb, colorImage.a);
								return material;
							}`,
						},
						translucent: () => true,
					});

					function PolylineFlowLineMaterialProperty(materialOptions = {}) {
						this._definitionChanged = new Cesium.Event();
						this.color = materialOptions.color || Cesium.Color.WHITE;
						this.duration = materialOptions.duration || 2400;
						this.repeat = materialOptions.repeat || new Cesium.Cartesian2(6, 1);
						this._startTime = Date.now();
					}

					Object.defineProperties(PolylineFlowLineMaterialProperty.prototype, {
						isConstant: {
							get() {
								return false;
							},
						},
						definitionChanged: {
							get() {
								return this._definitionChanged;
							},
						},
					});

					PolylineFlowLineMaterialProperty.prototype.getType = function() {
						return Cesium.Material.PolylineFlowLineType;
					};

					PolylineFlowLineMaterialProperty.prototype.getValue = function(time, result) {
						const materialResult = result || {};
						materialResult.color = this.color;
						materialResult.image = Cesium.Material.PolylineFlowLineImage;
						materialResult.repeat = this.repeat;
						materialResult.time = ((Date.now() - this._startTime) % this.duration) / this.duration;
						return materialResult;
					};

					PolylineFlowLineMaterialProperty.prototype.equals = function(other) {
						return this === other;
					};

					Cesium.PolylineFlowLineMaterialProperty = PolylineFlowLineMaterialProperty;
				}

				return new Cesium.PolylineFlowLineMaterialProperty({
					color: options.color || Cesium.Color.WHITE,
					duration: options.duration || 2400,
					repeat: options.repeat || new Cesium.Cartesian2(6, 1),
				});
			},

			/**
			 * ================================================================
			 * 5.7 适配地图视野
			 * ================================================================
			 */
			fitToGansu() {
				let allLons = [];
				let allLats = [];

				this.gansuBorderCoords.forEach((ring) => {
					ring.forEach((coord) => {
						allLons.push(coord[0]);
						allLats.push(coord[1]);
					});
				});

				const minLon = Math.min(...allLons);
				const maxLon = Math.max(...allLons);
				const minLat = Math.min(...allLats);
				const maxLat = Math.max(...allLats);

				const centerLon = (minLon + maxLon) / 2;
				const centerLat = (minLat + maxLat) / 2;

				const lonSpan = maxLon - minLon;
				const latSpan = maxLat - minLat;
				const maxSpan = Math.max(lonSpan, latSpan);

				let zoom = this.zoom;
				if (maxSpan < 1) zoom =  this.zoom;
				if (maxSpan < 0.5) zoom =  this.zoom+1;
				if (maxSpan < 0.2) zoom =  this.zoom + 2;

				// 2D 视角单独维护，避免与 3D 相机参数混用
				this.apply2DView();

				console.log(`✅ 地图视野已适配：中心(${centerLon}, ${centerLat})，缩放${zoom}`);
			},

			/**
			 * ================================================================
			 * 5.8 备用遮罩
			 * ================================================================
			 */
			createFallbackMask() {
				console.warn('⚠️ 使用备用遮罩');

				const gansuSimulated = [
					[94.0, 38.0],
					[95.0, 39.0],
					[96.0, 40.0],
					[97.0, 41.0],
					[98.0, 42.0],
					[99.0, 41.0],
					[100.0, 40.0],
					[101.0, 39.0],
					[102.0, 38.0],
					[103.0, 37.0],
					[104.0, 36.0],
					[105.0, 35.0],
					[106.0, 34.0],
					[107.0, 33.0],
					[108.0, 34.0],
					[109.0, 35.0],
					[108.0, 36.0],
					[107.0, 37.0],
					[106.0, 38.0],
					[105.0, 39.0],
					[104.0, 40.0],
					[103.0, 41.0],
					[102.0, 42.0],
					[101.0, 42.5],
					[100.0, 42.0],
					[99.0, 41.5],
					[98.0, 41.0],
					[97.0, 40.0],
					[96.0, 39.0],
					[95.0, 38.5],
					[94.0, 38.0],
				];

				const worldBounds = [
					[-180, -90],
					[180, -90],
					[180, 90],
					[-180, 90],
					[-180, -90],
				];

				const gansuProjected = gansuSimulated.map((coord) => fromLonLat(coord));
				const worldProjected = worldBounds.map((coord) => fromLonLat(coord));

				const maskPolygon = new Polygon([worldProjected, gansuProjected]);
				const maskFeature = new Feature({
					geometry: maskPolygon,
				});

				maskFeature.setStyle(
					new Style({
						fill: new Fill({
							color: 'rgba(35, 54, 34, 0.78)',
						}),
						stroke: new Stroke({
							color: 'rgba(35, 54, 34, 0.18)',
							width: 1,
						}),
					})
				);

				const maskSource = new VectorSource({
					features: [maskFeature],
				});

				const maskLayer = new VectorLayer({
					source: maskSource,
					zIndex: 20,
					name: '遮罩层',
				});

				this.map.addLayer(maskLayer);
				console.log('✅ 备用遮罩添加成功');
			},

			/**
			 * ================================================================
			 * 5.9 切换 2D/3D 模式（核心）
			 * ================================================================
			 */
				toggle3D() {
					if (!this.ol3d) return;

				if (this.cesiumInitTimer) {
					clearTimeout(this.cesiumInitTimer);
					this.cesiumInitTimer = null;
				}

				this.is3D = !this.is3D;
				this.ol3d.setEnabled(this.is3D);

				if (this.is3D) {
					this.set2DMarkerVisibility(false);
					this.set2DOverlayVisibility(false);
					// 移除 2D 围栏
					this.removeFenceLayers();
					this.removeCesiumFence();

					// 等待 Cesium 场景初始化完成
					const waitForScene = (retryCount = 0) => {
						const scene = this.ol3d.getCesiumScene();
						const entities = this.getCesiumEntities();
						if (scene && scene.camera && entities) {
							this.cesiumInitTimer = null;
							// 场景已就绪，添加围栏并应用独立 3D 相机视角
							this.addCesium3DFence();
							this.addDevicePolygonsTo3DMap(this.devicePolygonList);
							this.initCesiumClickHandler();
							this.apply3DView();
							if (scene.requestRender) {
								scene.requestRender();
							}
						} else {
							if (retryCount >= 10) {
								this.cesiumInitTimer = null;
								console.error('❌ Cesium 场景初始化超时，切换 3D 失败');
								this.is3D = false;
								this.ol3d.setEnabled(false);
								this.createFenceEffect();
								return;
							}

							this.cesiumInitTimer = setTimeout(() => {
								waitForScene(retryCount + 1);
							}, 300);
						}
					};

					waitForScene();
				} else {
					// 切换到 2D
					this.removeCesiumFence();
					this.set2DMarkerVisibility(true);
					this.set2DOverlayVisibility(true);
					this.apply2DView();
					this.createFenceEffect();
				}
			},

			/**
			 * ================================================================
			 * 5.10 添加 Cesium 3D 立体围栏
			 * ================================================================
			 */
			addCesium3DFence() {
				const entities = this.getCesiumEntities();
				const Cesium = window.Cesium;

				if (!entities || !Cesium) {
					console.error('❌ Cesium 实体集合不可用，无法创建 3D 围栏');
					return;
				}

				if (!this.gansuBorderCoords.length) {
					console.warn('⚠️ 未加载到甘肃边界数据，跳过 3D 围栏创建');
					return;
				}

				const FENCE_BASE_HEIGHT = 0;
				const FENCE_HEIGHT = 15000;
				const wallMaterial = this.createFenceGradientMaterial(Cesium);
				const topSurfaceMaterial = this.createTopSurfaceMaterial(Cesium);
				const flowLineMaterial = this.createFlowLineMaterial(Cesium, {
					color: Cesium.Color.fromCssColorString('rgba(220, 255, 245, 0.92)'),
					duration: 2800,
					repeat: new Cesium.Cartesian2(7, 1),
				});
				const maskOuterRing = [
					[70, 0],
					[140, 0],
					[140, 60],
					[70, 60],
					[70, 0],
				];

				const holes = this.gansuBorderCoords
					.filter((ring) => ring && ring.length >= 3)
					.map((ring) => {
						const closedRing = [...ring, ring[0]];
						return new Cesium.PolygonHierarchy(
							Cesium.Cartesian3.fromDegreesArray(closedRing.flat())
						);
					});

				entities.add({
					name: '3D区域遮罩',
					polygon: {
						hierarchy: new Cesium.PolygonHierarchy(
							Cesium.Cartesian3.fromDegreesArray(maskOuterRing.flat()),
							holes
						),
						material: Cesium.Color.fromCssColorString('#233622').withAlpha(0.8),
						height: 0,
						outline: false,
					},
				});

				this.gansuBorderCoords.forEach((ring) => {
					if (!ring || ring.length < 2) return;

					const closedRing = [...ring, ring[0]];
					const polygonHierarchy = new Cesium.PolygonHierarchy(
						Cesium.Cartesian3.fromDegreesArray(closedRing.flat())
					);
					const topHeight = FENCE_BASE_HEIGHT + FENCE_HEIGHT;

					const positionsGround = closedRing.map((coord) =>
						Cesium.Cartesian3.fromDegrees(coord[0], coord[1], FENCE_BASE_HEIGHT)
					);

					const positionsTop = closedRing.map((coord) =>
						Cesium.Cartesian3.fromDegrees(coord[0], coord[1], topHeight)
					);

					entities.add({
						name: '3D光晕墙体',
						polygon: {
							hierarchy: polygonHierarchy,
							height: FENCE_BASE_HEIGHT,
							extrudedHeight: topHeight,
							material: wallMaterial,
							outline: false,
							perPositionHeight: false,
							closeTop: false,
							closeBottom: false,
						},
					});

					// 顶面只保留一层很轻的阴影，避免区域看起来是平的
					entities.add({
						name: '3D区域顶面',
						polygon: {
							hierarchy: polygonHierarchy,
							height: topHeight,
							material: topSurfaceMaterial,
							outline: false,
							perPositionHeight: false,
						},
					});

					entities.add({
						name: '3D主围栏',
						polyline: {
							positions: positionsTop,
							width: 4,
							material: new Cesium.PolylineGlowMaterialProperty({
								glowPower: 0.22,
								color: Cesium.Color.fromCssColorString('rgba(255, 255, 255, 0)'),
							}),
						},
					});

					entities.add({
						name: '3D顶部流动线',
						polyline: {
							positions: positionsTop,
							width: 8,
							material: flowLineMaterial,
						},
					});

					entities.add({
						name: '3D发光线条',
						polyline: {
							positions: positionsGround,
							width: 4,
							material: new Cesium.PolylineGlowMaterialProperty({
								glowPower: 0.16,
								color: Cesium.Color.fromCssColorString('rgba(255, 255, 255, 0.18)'),
							}),
						},
					});
				});

				// 3D 模式下使用 Cesium 原生标记点，替代高德 Marker + setContent 的 DOM 方案
				this.addCesiumCustomMarker({
					name: '新敦镇双堡村',
					position: [100.362315, 38.904672],
					height: FENCE_BASE_HEIGHT,
					image: '/xin-dun-shuangbao.png',
					width: 134,
					heightPx: 137,
					offset: [0, 8],
				});

				// 对应高德 icon 标记：固定到指定坐标，仅显示图片图标
				this.addCesiumCustomMarker({
					name: '张掖市',
					position: [101.262315, 39.404672],
					height: FENCE_BASE_HEIGHT,
					image: '/zhangye-city.png',
					width: 154,
					heightPx: 134,
					offset: [-13, -30],
				});

				console.log('✅ Cesium 3D 立体围栏添加成功');
			},


			/**
			 * ================================================================
			 * 5.11 移除 Cesium 3D 围栏
			 * ================================================================
			 */
			removeCesiumFence() {
				const entities = this.getCesiumEntities();
				if (!entities) return;

				const toRemove = [];
				entities.values.forEach((entity) => {
					if (this.cesiumFenceNames.includes(entity.name) || entity.entityType === '3D自定义标记点') {
						toRemove.push(entity);
					}
					if (entity.entityType === '3D地块面') {
						toRemove.push(entity);
					}
				});

				toRemove.forEach((entity) => {
					entities.remove(entity);
				});

				console.log(`✅ 已移除 ${toRemove.length} 个 Cesium 围栏实体`);
			},

		},
	};
</script>

<style scoped lang="scss">
	#map-container {
		width: 100vw;
		height: 100vh;
		position: fixed;
		left: 0;
		top: 0;
		z-index: 1;
	}

	.map-root {
		position: fixed;
		left: 0;
		top: 0;
		width: 100vw;
		height: 100vh;
	}

	.dialog-mask {
		position: fixed;
		inset: 0;
		z-index: 2000000;
		background: rgba(0, 0, 0, 0.38);
		display: flex;
		align-items: center;
		justify-content: center;
	}

	.dialog-card {
		position: relative;
		min-width: 420px;
		max-width: 860px;
		padding: 22px;
		border-radius: 18px;
		background: #071f39;
		color: #fff;
		box-shadow: 0 18px 48px rgba(0, 0, 0, 0.34);
		z-index: 999999;
	}

	.dialog-title {
		font-size: 22px;
		font-weight: 700;
		color: #addaff;
	}

	.dialog-close {
		position: absolute;
		right: 32px;
		top: 32px;
		font-size: 28px;
		line-height: 1;
		cursor: pointer;
	}

	.dialog-content {
		margin-top: 18px;
		font-size: 16px;
		line-height: 1.8;
	}

	.text-grid {
		display: grid;
		grid-template-columns: repeat(2, minmax(180px, 1fr));
		gap: 10px 18px;
	}

	.video-card {
		width: 860px;
	}

	.video-box {
		width: 800px;
		height: 450px;
		margin-top: 16px;
		border-radius: 12px;
		overflow: hidden;
	}

	.irrigation-card {
		padding-top: 44px;
	}
.sqtext {
		font-size: 16px;
		color: #fff;
		line-height: 40px;
		padding-left: 10px;
	}

	.dialog {
		width: 100vw;
		height: 100vh;
		position: fixed;
		top: 0;
		left: 0;
		z-index: 999999;

		.dialog-close {
			width: 30px;
			height: 30px;
			position: absolute;
			right: 20px;
			top: 10px;
			z-index: 999999;
			cursor: pointer;
		}

		.table-name {
			font-size: 20px;
		}

		.table-search {
			font-size: 15px;
		}

		/* 移除所有内部边框 */
		.outer-border-table>>>.el-table__body tr td,
		.outer-border-table>>>.el-table__body tr th,
		.outer-border-table>>>.el-table__header-wrapper tr th {
			border: none !important;
		}

		/* 添加外边框 */
		.outer-border-table {
			border: 1px solid #ebeef5;
			border-radius: 4px;
		}

		/* 移除默认的表格边框 */
		.outer-border-table>>>.el-table__header,
		.outer-border-table>>>.el-table__body,
		.outer-border-table>>>.el-table__footer {
			border: none !important;
		}

		.search {
			height: 31px;
			line-height: 31px;
			background: #366ec0;
			border-radius: 4px;
			text-align: center;
			font-family: PingFangSC, PingFang SC;
			font-weight: 500;
			font-size: 14px;
			color: #ffffff;
			margin-right: 10px;
			padding: 0 10px;
			cursor: pointer;
		}

		.search2 {
			height: 31px;
			background: #366ec0;
			border-radius: 4px;
			text-align: center;
			font-family: PingFangSC, PingFang SC;
			font-weight: 500;
			font-size: 14px;
			color: #ffffff;
			margin-right: 10px;
			padding: 0 10px;
			cursor: pointer;
		}

		.mask {
			width: 100vw;
			height: 100vh;
			z-index: 1500;
			background-color: rgba(0, 0, 0, 0.3);
			position: absolute;
		}

		.cont {
			position: relative;
			z-index: 1501;
			background-color: #fff;
			border-radius: 20px;
		}
	}

	.custom-content-marker {
		font-weight: 900;
		font-size: 36px;
		color: #f6e18b;
		text-shadow: 0px 4px 10px rgba(0, 0, 0, 0.3);
		width: 200px;
		display: flex;
		flex-direction: column;
		align-items: center;
	}

	#contnChow1232 {
		border-radius: 5px;
		width: 100vw;
		height: 100vh;
		position: relative;

		color: #7ebe7a;
	}

	.cq {
		.sd {
			width: 90px;
			height: 30px;
			background-image: url("https://ica.obs.cn-south-1.myhuaweicloud.com/screen/fourEmotions/%E6%89%8B%E5%8A%A8%402x%20%282%29.png");
			background-size: 100% 100%;

			font-weight: 500;
			font-size: 14px;
			color: #fff;
			line-height: 30px;
			text-align: center;
		}

		.zd {
			width: 90px;
			height: 30px;
			background-image: url("https://ica.obs.cn-south-1.myhuaweicloud.com/screen/fourEmotions/%E8%87%AA%E5%8A%A8%402x%20%281%29.png");
			background-size: 100% 100%;

			font-weight: 500;
			font-size: 14px;
			color: #fff;
			line-height: 30px;
			text-align: center;
		}

		/* 修改选中时的背景色 */
		::v-deep .el-switch.is-checked .el-switch__core {
			background-color: rgba(0, 180, 255, 0.4) !important;
			border-color: #53c556 !important;
		}

		/* 修改未选中时的背景色 */
		::v-deep .el-switch__core {
			background-color: #a19f9f !important;
			// border-color: #b2b2b2 !important;
		}

		.ai-list {
			width: 620px;
			height: 36px;
			background-image: url("https://ica.obs.cn-south-1.myhuaweicloud.com/screen/fourEmotions/ai%E4%BF%A1%E6%81%AF%E6%A0%8F%402x.png");
			background-size: 100% 100%;

			font-weight: 400;
			font-size: 14px;
			color: #ffffff;
			text-align: center;
		}

		.aifx-title {
			width: 620px;
			height: 36px;
			background-image: url("https://ica.obs.cn-south-1.myhuaweicloud.com/screen/fourEmotions/ai%E6%A0%87%E9%A2%98%E6%A0%8F%402x.png");
			background-size: 100% 100%;

			font-weight: 500;
			font-size: 14px;
			color: #00ffd1;
			text-align: center;
		}

		.el-input__inner {
			background: linear-gradient(180deg,
					rgba(0, 87, 202, 0.3) 0%,
					rgba(0, 23, 54, 0.64) 100%) !important;
			border-radius: 2px !important;
			border: 1px solid !important;
			border-image: linear-gradient(124deg,
					rgba(156, 211, 225, 0),
					rgba(194, 243, 255, 1),
					rgba(156, 211, 225, 0)) 1 1 !important;
		}

		::v-deep .el-range-input {
			background: rgba(156, 211, 225, 0) !important;
			cursor: pointer;
		}

		::v-deep .el-range-separator {
			color: #fff !important;
		}

		.cjsj {
			font-weight: 400;
			font-size: 14px;
			color: #ffffff;
			margin-right: 10px;
		}

		.search {
			width: 73px;
			height: 31px;
			background: #366ec0;
			border-radius: 2px;

			font-family: PingFangSC, PingFang SC;
			font-weight: 500;
			font-size: 14px;
			color: #ffffff;
		}

		.cq-right-top-title2 {
			font-weight: 400;
			font-size: 14px;
			color: #ffffff;
			margin-right: 2px;
			width: 60px;
		}

		.cq-right-top-title {
			font-weight: 400;
			font-size: 14px;
			color: #ffffff;
			margin-right: 12px;
			width: 60px;
		}

		.switch-group {
			display: flex;
			flex-direction: column;
			/* 垂直方向 */
			align-items: center;
			/* 居中对齐 switch 与文字 */
			margin-top: -20px;
		}

		.cq-right-top-status {
			// font-weight: 400;
			font-size: 14px;
			color: #ffffff;
			margin-bottom: 4px;
			/* 状态文字与 switch 间距 */
		}

		.paizhao {
			width: 88px;
			height: 30px;
			background-image: url("https://ica.obs.cn-south-1.myhuaweicloud.com/screen/fourEmotions/%E6%8B%8D%E7%85%A7%E8%83%8C%E6%99%AF%402x.png");
			background-size: 100% 100%;

			font-weight: 400;
			font-size: 14px;
			color: #ffffff;
			margin-right: 20px;
		}
	}

	.fout-emotions-title {
		height: 38px;
		background-image: url("https://ica.obs.cn-south-1.myhuaweicloud.com/screen/fourEmotions/%E6%A0%87%E9%A2%98%402x%20%281%29.png");
		background-size: 100% 100%;
		font-family: YouSheBiaoTiHei;
		font-size: 20px;
		color: #c4dcf0;
		line-height: 38px;
		padding-left: 30px;
	}
</style>
